import { render } from "./HiSearchInput.vue?vue&type=template&id=dc384d8e"
import script from "./HiSearchInput.vue?vue&type=script&lang=js"
export * from "./HiSearchInput.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__